import { VersionConfigModel } from "./models/config";

export const VersionConfig: VersionConfigModel = {
  VERSION: "2.3.1.81",
  VERSION_CODE: 230181
};